module.exports = __webpack_public_path__ + "img/profitable-img-mobile-2.969d3178.png";